const notLogoutRoutes = ['auth','login', 'logout', 'passwordRecovery', 'forgot-password'];

module.exports = {
  notLogoutRoutes
};
